var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal",
      class: { "d-block": _vm.opened },
      attrs: { id: _vm.id, tabindex: "-1", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-bgr", on: { click: _vm.close } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("span", { staticClass: "close", on: { click: _vm.close } }, [
              _c("i", { staticClass: "icon icon-close" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body pt-5 pb-4" }, [
              _c("p", { staticClass: "text-center m-0" }, [
                _vm._v(_vm._s(_vm.message)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer justify-content-center" }, [
              _vm.showCancel
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-neutral",
                      attrs: { type: "button" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.btnCancelText) + "\n                ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn",
                  class: `btn-${_vm.button}`,
                  attrs: { type: "button" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(_vm._s(_vm.btnText) + "\n                ")]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }